import { Store, Eye, Trash2, Flag, FileCheck, FileX } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const ListingsTab = ({
  listings,
  listingFilter,
  setListingFilter,
  onFlag,
  onDelete,
  onVerifyHealthDocs,
  canDelete = false,
}) => (
  <div>
    <div className="flex items-center gap-2 mb-4">
      <select
        value={listingFilter}
        onChange={(e) => setListingFilter(e.target.value)}
        className="input-minimal w-auto"
        data-testid="listing-filter"
      >
        <option value="all">All Listings</option>
        <option value="active">Active</option>
        <option value="paused">Paused</option>
        <option value="sold">Sold</option>
      </select>
    </div>

    <div className="space-y-3">
      {listings.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <Store className="w-12 h-12 text-[#3F3F46] mx-auto mb-3" />
          <p className="text-[#A1A1AA]">No listings found</p>
        </div>
      ) : (
        listings.map((listing) => (
          <div
            key={listing.listing_id}
            className={`glass-card p-4 ${listing.is_flagged ? "border-[#EF4444]/50" : ""}`}
          >
            <div className="flex items-start justify-between">
              <div className="flex gap-4">
                <div className="w-20 h-20 rounded-lg bg-[#18181B] overflow-hidden flex-shrink-0">
                  {listing.photos?.[0] ? (
                    <img src={listing.photos[0]} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-2xl">🐾</div>
                  )}
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h4 className="text-[#EDEDED] font-medium">{listing.title}</h4>
                    <StatusBadge status={listing.status} />
                    {listing.is_flagged && (
                      <span className="px-2 py-0.5 text-xs rounded bg-[#EF4444] text-white">
                        Flagged
                      </span>
                    )}
                    {listing.verified_documents && (
                      <span className="px-2 py-0.5 text-xs rounded bg-[#22C55E]/10 text-[#22C55E] flex items-center gap-1">
                        <FileCheck className="w-3 h-3" /> Health Verified
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-[#A1A1AA]">
                    {listing.species} • {listing.breed} • ${listing.price?.toLocaleString()}
                  </p>
                  <p className="text-xs text-[#71717A] mt-1">
                    {listing.owner_type === "shelter" ? "🏠" : "🏷️"} {listing.owner_name}
                  </p>
                  <p className="text-xs text-[#52525B]">
                    {listing.location_city}, {listing.location_state} • {listing.listing_type}
                    {listing.health_docs?.length > 0 && (
                      <span className="ml-2 text-[#71717A]">
                        • {listing.health_docs.length} health doc(s)
                      </span>
                    )}
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                {listing.health_docs?.length > 0 && (
                  <button
                    onClick={() => onVerifyHealthDocs(listing.listing_id, !listing.verified_documents)}
                    className={`p-2 rounded-lg border transition-colors ${
                      listing.verified_documents
                        ? "border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E]/10"
                        : "border-[#3F3F46] text-[#A1A1AA] hover:border-[#22C55E] hover:text-[#22C55E]"
                    }`}
                    title={listing.verified_documents ? "Remove Health Verification" : "Verify Health Docs"}
                    data-testid={`verify-health-${listing.listing_id}`}
                  >
                    {listing.verified_documents ? <FileCheck className="w-4 h-4" /> : <FileX className="w-4 h-4" />}
                  </button>
                )}
                <a
                  href={`/listing/${listing.listing_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg border border-[#3F3F46] text-[#A1A1AA] hover:border-[#71717A] transition-colors"
                  title="View"
                  data-testid={`view-listing-${listing.listing_id}`}
                >
                  <Eye className="w-4 h-4" />
                </a>
                <button
                  onClick={() => onFlag(listing.listing_id, !listing.is_flagged)}
                  className={`p-2 rounded-lg border transition-colors ${
                    listing.is_flagged
                      ? "border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10"
                      : "border-[#3F3F46] text-[#A1A1AA] hover:border-[#EF4444] hover:text-[#EF4444]"
                  }`}
                  title={listing.is_flagged ? "Unflag" : "Flag"}
                  data-testid={`flag-listing-${listing.listing_id}`}
                >
                  <Flag className="w-4 h-4" />
                </button>
                {canDelete && (
                  <button
                    onClick={() => onDelete(listing.listing_id)}
                    className="p-2 rounded-lg border border-[#3F3F46] text-[#A1A1AA] hover:border-[#EF4444] hover:text-[#EF4444] transition-colors"
                    title="Delete"
                    data-testid={`delete-listing-${listing.listing_id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
